import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource, useResource } from '@atlassian/react-resource-router';

export const currentUserResource = createResource({
	type: 'CURRENT_USER',
	getKey: () => 'current-user-key',
	getData: async (routerContext, { tenantContext: { atlassianAccountId } }) => {
		if (!atlassianAccountId) {
			return null;
		}

		return performGetRequest(`/rest/api/2/user?accountId=${atlassianAccountId}`);
	},
});

export function useCurrentUserResource() {
	return useResource(currentUserResource);
}
